import { ValuableModel } from '../../models/ValuableModel'

export class SchemaUnknownModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Unknown': SchemaUnknownModel
  }
}
